module.exports = __webpack_public_path__ + "media/images/whatwedo-bb0e7cc5b1cd0718eb780655b60d618e.png";